/* eslint-disable import/no-anonymous-default-export */
import BranchDCBReportActionTypes from './branch-DCB-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getBranchDCBReportListResponse: null,
	getBranchDCBReportListArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET BRANCH DCB REPORT START *********************** */
		case BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_SUCCESS:
			return {
				...state,
				getBranchDCBReportListResponse: action.payload,
				getBranchDCBReportListArr: docodeHexResponse(
					action.payload,
					'GetBranchDCBReportKey',
				),
			};

		case BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_FAILURE:
			return { ...state, getBranchDCBReportListResponse: action.payload };

		case BranchDCBReportActionTypes.GET_BRANCH_DCB_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getBranchDCBReportListResponse: null };

		/** ***************** GET BRANCH DCB REPORT START *********************** */

		default:
			return state;
	}
};
